<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div class="myChart" ref="myChart" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'connection-number',
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          title: {
            textStyle: {
              color: '#6a9cd5',
            },
            left: 'center',
          },
          tooltip: {
            //鼠标悬浮弹出提示框
            trigger: 'axis', //提示框弹出的触发时间，折线图和柱状图为axis
            formatter: '{b} : {c} ', //提示框提示的信息，{a}series内的名字，{b}为块状的名字，{c}为数值
          },
          grid: {
            //统计图距离边缘的距离
            top: '8%',
            left: '10%',
            right: '10%',
            bottom: '15%',
          },
          xAxis: [
            {
              //x轴
              type: 'category', //数据类型为不连续数据
              boundaryGap: true, //坐标轴两边是否留白
              axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                  color: '#FFFFFF', //x轴颜色
                },
              },
              axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                  color: '#FFFFFF',
                },
                padding: 5,
              },
              axisTick: {
                show: false,
              }, //刻度点数轴
              data: [
                '01时',
                '02时',
                '03时',
                '04时',
                '05时',
                '06时',
                '07时',
                '08时',
              ],
            },
          ],
          yAxis: [
            {
              //y轴的相关设置
              type: 'value', //y轴数据类型为连续的数据
              min: 0, //y轴上的刻度最小值
              max: 600, //y轴上的刻度最大值
              splitLine: {
                //y轴上的y轴线条相关设置
                show: true,
                lineStyle: {
                  color: '#233e64',
                },
              },
              axisLine: {
                //y轴的相关设置
                show: false,
                lineStyle: {
                  color: '#233e64', //y轴颜色
                },
              },
              axisLabel: {
                //y轴的标签相关设置
                textStyle: {
                  color: '#FFFFFF',
                },
              },
              axisTick: {
                show: true,
              }, //刻度点数轴
            },
          ],
          series: [
            {
              type: 'line', //统计图类型为折线图
              smooth: true, //是否平滑曲线显示
              symbolSize: 0, //数据点的大小，[0,0]//b表示宽度和高度
              lineStyle: {
                //线条的相关设置
                normal: {
                  color: 'rgba(37, 113, 252, 1)', // 线条颜色
                },
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'rgba(37, 113, 252, 0.9)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(37, 113, 252, 0)',
                      },
                    ],
                    false
                  ),

                  shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                  shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                },
              },
              data: [150, 400, 380, 120, 280, 200, 140, 580],
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 100%;
      height: 10.416vw;
      margin: 0 auto;

      .myChart {
        width: 100%;
        height: 10.416vw;
      }
    }
  }
</style>
